var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PdfViewer',{ref:_vm.viewerKey,attrs:{"saveDocumentChanges":_vm.saveDocumentChanges && _vm.editPermission,"isResizing":_vm.isResizing},on:{"document-file-updated":_vm.updateDocumentFile}})}
var staticRenderFns = []

export { render, staticRenderFns }